import { z } from 'zod'
import { oc } from '@orpc/contract'

export const recordsFacilityCreate = oc
  .route({ method: 'POST', path: '/v2/facility' })
  .input(
    z.object({
      name: z.string().min(1),
      street: z.string().min(1),
      city: z.string().min(1),
      state: z.string().min(1),
      zip: z.string().min(1),
      fax: z.string().optional(),
      phone: z.string().optional(),
    }),
  )
  .output(z.object({ id: z.string() }))
